import { Button } from "@legal-500/legal500-design-system";
import { useId, useState } from "react";
import styles from "../PipelineBrowser.module.css";

const VISIBLE_LIST_ROWS = 6;

type CopyableListProps = {
  label: string;
  lines: string[];
};

export function CopyableList({ label, lines }: CopyableListProps) {
  const id = useId();
  const [copied, setCopied] = useState(false);
  const text = lines.join("\n");

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div>
      <div className={styles.syncStateRow}>
        <label className={styles.syncStateLabel} htmlFor={id}>
          {label} ({lines.length})
        </label>
        <Button variant="outlined" color="secondary" size="small" onClick={handleCopy}>
          {copied ? "Copied" : `Copy ${label.toLowerCase()}`}
        </Button>
      </div>
      <textarea
        id={id}
        className={styles.idList}
        readOnly
        rows={Math.min(lines.length, VISIBLE_LIST_ROWS)}
        value={text}
      />
    </div>
  );
}
